import { ResultsWidget } from "../ResultsWidget";
import { ResultsController } from "../Tools/ResultsController";
declare var PlanManager: any;
declare var AssetManagerServices: any;
declare var Savane: any;
declare var DecorationService: any;
export class ResultsOverlayWidget {
    controller: ResultsController;
    static allArrangementObjects: any | null = null;//(typeof PlanManager === 'undefined') ? [] : PlanManager.getInstance().world.currentScene.arrangementObjects;
    static allCoatingObjects: any | null = null;//(typeof PlanManager === 'undefined') ? [] : PlanManager.getInstance().world.currentScene.coatings;
    static allGroupObjects: any | null = null;//(typeof PlanManager === 'undefined') ? [] : PlanManager.getInstance().world.currentScene.arrangementGroups;
    static projectLoaded = Savane.eventsManager.instance.addListener(Savane.Events.PROJECT_DID_LOAD, ResultsOverlayWidget.refreshArrangementObjectList);
    static projectUpdated = Savane.eventsManager.instance.addListener(Savane.Events.UPDATE_RHINOV_FORMAT, ResultsOverlayWidget.refreshArrangementObjectList);
    static reloadListener = Savane.eventsManager.instance.addListener(Savane.Events.PROJECT_RELOAD, ResultsOverlayWidget.refreshArrangementObjectList);
    static componentAddedListener = Savane.eventsManager.instance.addListener(Savane.Events.COMPONENT_ADDED, ResultsOverlayWidget.refreshArrangementObjectList);
    static componentRemovedListener = Savane.eventsManager.instance.addListener(Savane.Events.COMPONENT_REMOVED, ResultsOverlayWidget.refreshArrangementObjectList);
    static commandListener: any;

    openUrl: (url: string) => void;
    openDetailsFunc: (url: string) => void;
    currentResource: any;

    constructor(openUrl: (url: string) => void, openDetailsFunc: (url: string) => void, currentResource: any) {
        this.openUrl = openUrl;
        this.openDetailsFunc = openDetailsFunc;
        this.currentResource = currentResource;
        this.controller = new ResultsController();
        ResultsOverlayWidget.commandListener = Savane.eventsManager.instance.addListener(Savane.Events.COMMAND_EXECUTED, function (event) {
            // Depending on the command name (see Command.js from CocosPlanModule/src/cocos/scripts/command)
            switch (event.userData.name) {
                case Savane.Commands.CommandEnum.AddEntityCommand:
                case Savane.Commands.CommandEnum.DeleteEntityCommand:
                    if (event.userData.datas.type === Savane.SceneConstants.EntityType.ArrangementObject) {
                        ResultsOverlayWidget.allArrangementObjects = PlanManager.getInstance().world.currentScene.arrangementObjects;
                    }
                    if (event.userData.datas.type === Savane.SceneConstants.EntityType.ArrangementGroup) {
                        ResultsOverlayWidget.allArrangementObjects = PlanManager.getInstance().world.currentScene.arrangementObjects;
                        ResultsOverlayWidget.allGroupObjects = PlanManager.getInstance().world.currentScene.arrangementGroups;
                    }
                    break;

                case Savane.Commands.CommandEnum.DeleteGroupCommand:
                    ResultsOverlayWidget.allGroupObjects = PlanManager.getInstance().world.currentScene.arrangementGroups;
                    break;

                case Savane.Commands.CommandEnum.ChangeCoatingCommand:
                case Savane.Commands.CommandEnum.DeleteComponentCommand:
                    ResultsOverlayWidget.allCoatingObjects = PlanManager.getInstance().world.currentScene.coatings;
                    break;
            }
        });
    }

    static refreshArrangementObjectList() {
        if (typeof PlanManager === 'undefined') {
            return;
        }

        ResultsOverlayWidget.allArrangementObjects = PlanManager.getInstance().world.currentScene.arrangementObjects;
        ResultsOverlayWidget.allCoatingObjects = PlanManager.getInstance().world.currentScene.coatings;
        ResultsOverlayWidget.allGroupObjects = PlanManager.getInstance().world.currentScene.arrangementGroups;
    };

    static isUsedInProject(resource) {
        var i;

        if (resource.kind === 'Arrangement') {
            if (ResultsOverlayWidget.allArrangementObjects === null) {
                ResultsOverlayWidget.allArrangementObjects = PlanManager.getInstance().world.currentScene.arrangementObjects;
            }
            for (i = 0; i < ResultsOverlayWidget.allArrangementObjects.length; i++) {
                if (resource._id === ResultsOverlayWidget.allArrangementObjects[i]._objectId) {
                    return (true);
                }
            }
        }

        if (resource.kind === 'Coating') {
            if (ResultsOverlayWidget.allCoatingObjects === null) {
                ResultsOverlayWidget.allCoatingObjects = PlanManager.getInstance().world.currentScene.coatings;
            }
            for (i = 0; i < ResultsOverlayWidget.allCoatingObjects.length; i++) {
                if (resource._id === ResultsOverlayWidget.allCoatingObjects[i]._coatingId) {
                    return (true);
                }
            }
        }

        if (!resource.kind) {
            if (ResultsOverlayWidget.allGroupObjects === null) {
                ResultsOverlayWidget.allGroupObjects = PlanManager.getInstance().world.currentScene.arrangementGroups;
            }
            for (i = 0; i < ResultsOverlayWidget.allGroupObjects.length; i++) {
                if (resource._id === ResultsOverlayWidget.allGroupObjects[i]._objectId) {
                    return (true);
                }
            }
        }

        return (false);
    };

    static generatePriceString(resource) {
        var priceString = '';
        if (resource.price !== undefined && resource.price.value !== undefined) {
            priceString = '' + resource.price.value;
            if (resource.price.currency !== undefined) {
                if (resource.price.currency === 'EUR') {
                    priceString += '€';
                }
                if (resource.price.currency === 'GBP') {
                    priceString += '£';
                }
                if (resource.price.currency === 'USD') {
                    priceString += '$';
                }
            }
        }
        return priceString;
    };

    static getAvailabilityTitle(resource) {
        if (resource.manufacturer._id !== '579b5fc0d7ee59f805e3c065') {
            return ("");
        }

        if (resource.pipeline.state === 'terminated') {
            return ("Rupture définitive");
        }

        if (resource.pipeline.state === 'archived') {
            return ("Rupture temporaire");
        }

        return ("Disponible");
    };

    static getAvailability(resource) {
        if (resource.manufacturer._id !== '579b5fc0d7ee59f805e3c065') {
            return ("rgb(211, 211, 211)");
        }

        if (resource.pipeline.state === 'terminated') {
            return ("rgb(255, 0, 0)");
        }

        if (resource.pipeline.state === 'archived') {
            return ("rgb(255, 188, 0)");
        }

        return ("rgb(211, 211, 211)");
    };

    static getTopFlop(resource) {
        if (resource.marketStatus === 'top' || resource.marketStatus === 'noos' || resource.saleState === 'on_sold') {
            return ("rgb(0, 128, 0);font-weight: 800");
        }
        if (resource.marketStatus === 'flop' && !resource.isNewProduct) {
            return ("rgb(255, 0, 0)");
        }
        return ("rgb(128, 128, 128)");
    };

    static openUrl(uri) {
        if (ResultsWidget.openDetailsFunc) {
            ResultsWidget.openDetailsFunc(uri);
        }
        else {
            window.open(uri);
        }
    };

    /**
     * Opent a tab in brower, pointing at AssetManager Item
     * @param {Object} resource The item retrieved from request result
     */
    static openAssetDetail(resource) {
        var uri = null;

        switch (ResultsWidget.getDecorationService().group) {
            case AssetManagerServices._ASSET_TYPE.ARRANGEMENTS:
                uri = AssetManagerServices.getFrontUrl() + 'arrangements/' + resource._id;
                break;

            case AssetManagerServices._ASSET_TYPE.COATINGS:
                uri = AssetManagerServices.getFrontUrl() + 'coatings/' + resource._id;
                break;

            case AssetManagerServices._ASSET_TYPE.TEMPLATES:
                uri = AssetManagerServices.getFrontUrl() + 'assets-groups/' + resource._id;
                break;

            case AssetManagerServices._ASSET_TYPE.JOINERIES:
                uri = AssetManagerServices.getFrontUrl() + 'joineries/' + resource._id;
                break;

            case AssetManagerServices._ASSET_TYPE.TECHNICAL_ELEMENTS:
                uri = AssetManagerServices.getFrontUrl() + 'technical-elements/' + resource._id; //@aurelien check typo
                break;

            case AssetManagerServices._ASSET_TYPE.TAGS:
                break;

            case 'allAssets':
            case 'nextobjects':
            case 'magicsearch':
                switch (resource.kind) {
                    case 'Arrangement':
                        uri = AssetManagerServices.getFrontUrl() + 'arrangements/' + resource._id;
                        break;

                    case 'Joinery':
                        uri = AssetManagerServices.getFrontUrl() + 'joineries/' + resource._id;
                        break;

                    case 'TechnicalElement':
                        uri = AssetManagerServices.getFrontUrl() + 'technical-elements/' + resource._id
                        break;

                    case 'Template':
                        uri = AssetManagerServices.getFrontUrl() + 'asset-groups/' + resource._id;
                        break;

                    case 'Coating':
                        uri = AssetManagerServices.getFrontUrl() + 'coatings/' + resource._id;
                        break;
                }
                break;

            default:
        }
        this.openUrl(uri);
    };

    static findAssetInScene(resource) {
        if (typeof PlanManager !== 'undefined') {
            var arrangements = PlanManager.getInstance().world.currentScene.arrangementObjects;
            var selection = [];

            for (var i = 0; i < arrangements.length; i++) {
                if (arrangements[i]._objectId === resource._id) {
                    if (!arrangements[i].parent.isArrangementObjectEntity() && !arrangements[i].parent.isArrangementGroupEntity()) {
                        selection.push(arrangements[i]);
                    }
                    else {
                        var parent = arrangements[i].parent;
                        while (parent.parent.isArrangementObjectEntity() || parent.parent.isArrangementGroupEntity()) {
                            parent = parent.parent;
                        }

                        selection.push(parent);
                    }
                }
            }

            PlanManager.getInstance().updateItemsSelected(selection, false, false);
        }
    };

    static mouseDownAsset(asset) {
        //Event on mouse down
        ResultsWidget.draggedRes = null;
        Savane.eventsManager.instance.dispatch(Savane.Events.STOP_UPDATING_ENVS);
        Savane.eventsManager.instance.dispatch(Savane.Events.HIDE_TOOLTIP_EVENT);
    };

    static sendReplaceArrangement(resource) {
        if (resource.kind === 'Arrangement' || resource.kind === undefined) {
            Savane.eventsManager.instance.dispatch(Savane.Events.REPLACE_SELECTED_ARRANGEMENT, resource);
        }
    };

    addOrRemoveFromPinboards() {
        Savane.eventsManager.instance.dispatch(Savane.Events.ADD_OR_REMOVE_FROM_PINBOARD, {
            item: this.currentResource,
        })
    };

    addOrRemoveFromAssetsGroupsList() {
        Savane.eventsManager.instance.dispatch(Savane.Events.ADD_OR_REMOVE_FROM_ASSETS_GROUPS_LIST, {
            item: this.currentResource,
        })
    };

    html() {
        return `
        <!-- Empty ressource container displayed on top of background image of the asset -->
        <div class="Empty-Res-Container" id="empty-${this.currentResource._id}" style="width:100%;height:100%;display:none;" data-no-drag>
            ${this.getUsageIndicatorHtml()}

            ${this.getNewOnSalesProductIndicatorHtml()}

            ${this.getPriceIndicatorHtml()}

            ${this.getFloorGeneratorBadgeHtml()}

            ${this.getAssetProblemIndicatorHtml()}

            ${this.getPinboardToggleHtml()}

            ${this.getAssetsGroupsListToggleHtml()}

            ${this.getMarketLinkHtml()}
        </div>
        `;
    }

    getUsageIndicatorHtml() {
        return `
        <!-- P1 priority displayed top left if manufacturer priority == p1 and ressource available, with green background-->
            <div id="checkmark-${this.currentResource._id}" style="position:absolute;top:${this.currentResource.isHpFloorGenerator ? '10px' : '-2px'};${ResultsOverlayWidget.isUsedInProject(this.currentResource) ? '' : 'display:none'};left:0;height:11px;cursor:pointer;font-size:16px;color:rgb(0, 192, 0);" title="Utilisé">
                <i class="glyphicon glyphicon-ok"></i>
            </div>
        `;
    }

    getNewOnSalesProductIndicatorHtml() {
        if (this.currentResource.saleState === "on_sale") {
            return `
            <!-- On sale product -->
                <div style="position:absolute;top:0;left:32px;height:12px;cursor:pointer;font-size:16px;color:rgb(0, 128, 0);" title="Soldé">
                    <i class="glyphicon glyphicon-star"></i>
                </div>
            `;
        }

        if (this.currentResource.isNewProduct) {
            return `
            <!-- New product -->
                <div style="position:absolute;top:0;left:32px;height:12px;cursor:pointer;font-size:16px;color:rgb(0, 102, 255);" title="Nouveauté">
                    <i class="glyphicon glyphicon-star"></i>
                </div>
            `;
        }

        return('');
    }

    getPriceIndicatorHtml() {
        return `
        <!-- asset price displayed bottom left -->
        <div style="position:absolute;bottom:0;left:0;height:12px;cursor:pointer;font-size:12px;background-color:rgb(255, 255, 255);color:${ResultsOverlayWidget.getTopFlop(this.currentResource)}" title="prix">
            ${ResultsOverlayWidget.generatePriceString(this.currentResource)}
        </div>
        `;
    }

    getFloorGeneratorBadgeHtml() {
        return `
        ${this.currentResource.isHpFloorGenerator ? `
            <div style="position:absolute;top:0;left:0;height:13px;cursor:pointer;font-size:12px;background-color:rgb(255, 255, 255);" title="FG">
              FG
            </div>
        `: ''}`;
    }

    getAssetProblemIndicatorHtml() {
        setTimeout(() => {
            const currentResource = this.currentResource;
            const elements = document.querySelectorAll('.res-overlay-'+this.currentResource._id);
            if(elements.length > 1){
                this.controller.removeEventListeners("mousedown", "res-overlay-"+this.currentResource._id, true);
                this.controller.removeEventListeners("mouseup", "res-overlay-"+this.currentResource._id, true);
            }
            this.controller.addEventListeners("mousedown", (event) => {
                if (event.ctrlKey) {
                    ResultsOverlayWidget.openAssetDetail(currentResource);
                } else if (event.altKey) {
                    ResultsOverlayWidget.findAssetInScene(currentResource);
                } else {
                    ResultsOverlayWidget.mouseDownAsset(currentResource);
                }
            }, 'res-overlay-' + this.currentResource._id, undefined, true);

            this.controller.addEventListeners("mouseup", (event) => {
                if (!event.ctrlKey && !event.altKey) {
                    ResultsOverlayWidget.sendReplaceArrangement(currentResource);
                }
            }, 'res-overlay-' + this.currentResource._id, undefined, true);
        }, 50);
        return `
        <div style="width:100%;height:100%;position:relative">
          ${this.currentResource.hasIssues && this.currentResource.manufacturer !== undefined ? `
            <div style="font-size:48px;color:rgb(255, 0, 0);display:flex;justify-content:center;align-items:center;height:100%" title="PROBLEMES !">
                <i class="glyphicon glyphicon-remove"></i>
            </div>
          ` : ''}
          <div class="res-overlay-${this.currentResource._id}" style="width:100%;height:100%;position:absolute;top:0;left:0" data-no-drag>
          </div>    
        </div>
        `;
    }

    getPinboardToggleHtml() {
        setTimeout(() => {
            const elements = document.querySelectorAll(`.Pinboard-${this.currentResource._id}`);

            if(elements.length > 1){
                this.controller.removeEventListeners("mousedown", `Pinboard-${this.currentResource._id}`);
            }

            this.controller.addEventListeners("mousedown", () => {
                this.addOrRemoveFromPinboards();
            }, `Pinboard-${this.currentResource._id}`, undefined, true);
        }, 50);
        const isPinnedClass = this.currentResource.pinboard ? 'pinned' : '';
        return `
        ${this.currentResource.manufacturer !== undefined ? `
            <div class="Pinboard-${this.currentResource._id}" style="position:absolute;top:0;right:0;height:13px;cursor:pointer;font-size:14px;" title="Pinboard">
              <i class="fas fa-heart pinboard ${isPinnedClass} isPinned-Icon-${this.currentResource._id}"></i>
            </div>
        ` : ''}`;
    }

    getAssetsGroupsListToggleHtml() {
        setTimeout(() => {
            const elements = document.querySelectorAll( `.AssetsGroupsList-${this.currentResource._id}`);

            if(elements.length > 1){
                this.controller.removeEventListeners("mousedown",  `AssetsGroupsList-${this.currentResource._id}`);
            }
            this.controller.addEventListeners("mousedown", () => {
                this.addOrRemoveFromAssetsGroupsList();
            }, `AssetsGroupsList-${this.currentResource._id}`, undefined, true);
        }, 50);
        return `
        ${this.currentResource.rhinovFormat !== undefined && ResultsWidget.getDecorationService().isUserAllowedToManageAssetsGroupsList ? `
            <div class="AssetsGroupsList-${this.currentResource._id}" style="position:absolute;top:0;right:0;height:13px;cursor:pointer;font-size:14px;" title="AssetsGroupsList">
                <i class="fas fa-cubes"></i>
            </div>
        ` : ''}`;
    }

    getMarketLinkHtml() {
        setTimeout(() => {
            const elements = document.querySelectorAll(`.Market-link-${this.currentResource._id}`);

            if(elements.length > 1){
                this.controller.removeEventListeners('mousedown', `Market-link-${this.currentResource._id}`);
            }
            this.controller.addEventListeners("mousedown", (event) => {
                this.openUrl(this.currentResource.marketLink);
                event.stopPropagation();
            }, `Market-link-${this.currentResource._id}`, undefined, true);
        }, 50);
        return `
        <!-- market link displayed bottom right -->
        ${this.currentResource.marketLink && this.currentResource.manufacturer !== undefined ? `
            <div class="Market-link-${this.currentResource._id}" style="position:absolute;bottom:0;right:0;height:12px;cursor:pointer;font-size:12px;background-color:rgb(255, 255, 255);
            color:${ResultsOverlayWidget.getAvailability(this.currentResource)}"
            title="${ResultsOverlayWidget.getAvailabilityTitle(this.currentResource)}">
                <i class="glyphicon glyphicon-shopping-cart"></i>
            </div>
        ` : ''}`;
    }

    destroy(): void {
        Savane.eventsManager.instance.removeListener(ResultsOverlayWidget.projectLoaded);
        Savane.eventsManager.instance.removeListener(ResultsOverlayWidget.projectUpdated);
        Savane.eventsManager.instance.removeListener(ResultsOverlayWidget.reloadListener);
        Savane.eventsManager.instance.removeListener(ResultsOverlayWidget.componentAddedListener);
        Savane.eventsManager.instance.removeListener(ResultsOverlayWidget.componentRemovedListener);
        Savane.eventsManager.instance.removeListener(ResultsOverlayWidget.commandListener);
    }
}